var _rect, _path, _g, _path2, _g2, _path3, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg13222AiPurp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7374,
    height: 2809,
    viewBox: "0 0 7374 2809",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_514_1112)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7374,
    height: 2809,
    fill: "#363741"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_514_1112",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 7374,
    height: 2809
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7374 2809H0V0H7374V2809Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_514_1112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4879.24 -212.321C4879.24 1856.57 3202.53 3533.2 1134.08 3533.2C-934.918 3533.2 -2611.62 1856.57 -2611.62 -212.321C-2611.62 -2280.67 -934.918 -3957.29 1134.08 -3957.29C3202.53 -3957.29 4879.24 -2280.67 4879.24 -212.321Z",
    fill: "url(#paint0_radial_514_1112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9239.45 -212.321C9239.45 1856.57 7562.74 3533.2 5493.74 3533.2C3425.29 3533.2 1748.58 1856.57 1748.58 -212.321C1748.58 -2280.67 3425.29 -3957.29 5493.74 -3957.29C7562.74 -3957.29 9239.45 -2280.67 9239.45 -212.321Z",
    fill: "url(#paint1_radial_514_1112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4330.58 -1221.8C4330.58 847.089 2653.87 2523.71 585.422 2523.71C-1483.58 2523.71 -3160.29 847.089 -3160.29 -1221.8C-3160.29 -3290.15 -1483.58 -4966.77 585.422 -4966.77C2653.87 -4966.77 4330.58 -3290.15 4330.58 -1221.8Z",
    fill: "url(#paint2_radial_514_1112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.516 1894.98C-1141.21 432.323 -1141.21 -1939.42 321.516 -3402.07C1784.25 -4864.18 4156.1 -4864.18 5618.83 -3402.07C7081.02 -1939.42 7081.02 432.323 5618.83 1894.98C4156.1 3357.63 1784.25 3357.63 321.516 1894.98Z",
    fill: "url(#paint3_radial_514_1112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3467.53 -5128.07C5535.99 -5128.07 7213.24 -3450.9 7213.24 -1382.55C7213.24 685.792 5535.99 2362.96 3467.53 2362.96C1399.08 2362.96 -278.172 685.792 -278.172 -1382.55C-278.172 -3450.9 1399.08 -5128.07 3467.53 -5128.07Z",
    fill: "url(#paint4_radial_514_1112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3781.92 716.515C2630.28 1868.1 763.737 1868.1 -387.353 716.515C-1538.99 -434.517 -1538.99 -2300.97 -387.353 -3452.55C763.737 -4603.58 2630.28 -4603.58 3781.92 -3452.55C4933.01 -2300.97 4933.01 -434.517 3781.92 716.515Z",
    fill: "url(#paint5_radial_514_1112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3094.45 -3437.73C4245.54 -2286.7 4245.54 -420.252 3094.45 731.328C1942.81 1882.36 76.2645 1882.36 -1074.83 731.328C-2226.46 -420.252 -2226.46 -2286.7 -1074.83 -3437.73C76.2645 -4589.31 1942.81 -4589.31 3094.45 -3437.73Z",
    fill: "url(#paint6_radial_514_1112)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_514_1112",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 7374,
    height: 2809
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7374 2809H0V0H7374V2809Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_514_1112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4128.67 128.929C4128.67 1142.8 3306.78 1965.2 2292.3 1965.2C1278.38 1965.2 456.484 1142.8 456.484 128.929C456.484 -884.944 1278.38 -1706.8 2292.3 -1706.8C3306.78 -1706.8 4128.67 -884.944 4128.67 128.929Z",
    fill: "url(#paint7_radial_514_1112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7397.59 -164.59C7397.59 849.284 6575.7 1671.68 5561.77 1671.68C4547.3 1671.68 3725.41 849.284 3725.41 -164.59C3725.41 -1178.46 4547.3 -2000.86 5561.77 -2000.86C6575.7 -2000.86 7397.59 -1178.46 7397.59 -164.59Z",
    fill: "url(#paint8_radial_514_1112)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_514_1112",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 7374,
    height: 2809
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H7374V2809H0V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_514_1112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1474.8 2698.72C1474.8 -528.334 4091.36 -3144.76 7318.59 -3144.76C10546.4 -3144.76 13162.9 -528.334 13162.9 2698.72C13162.9 5926.33 10546.4 8542.21 7318.59 8542.21C4091.36 8542.21 1474.8 5926.33 1474.8 2698.72Z",
    fill: "url(#paint9_radial_514_1112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5328.04 2698.72C-5328.04 -528.334 -2711.48 -3144.76 516.291 -3144.76C3743.51 -3144.76 6360.08 -528.334 6360.08 2698.72C6360.08 5926.33 3743.51 8542.21 516.291 8542.21C-2711.48 8542.21 -5328.04 5926.33 -5328.04 2698.72Z",
    fill: "url(#paint10_radial_514_1112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2330.71 4273.85C2330.71 1046.24 4947.27 -1569.64 8174.5 -1569.64C11402.3 -1569.64 14018.8 1046.24 14018.8 4273.85C14018.8 7500.91 11402.3 10117.3 8174.5 10117.3C4947.27 10117.3 2330.71 7500.91 2330.71 4273.85Z",
    fill: "url(#paint11_radial_514_1112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8585.99 -588.683C10868.4 1693.63 10868.4 5393.61 8585.99 7675.37C6304.11 9957.69 2603.95 9957.69 321.517 7675.37C-1960.91 5393.61 -1960.91 1693.63 321.517 -588.683C2603.95 -2871 6304.11 -2871 8585.99 -588.683Z",
    fill: "url(#paint12_radial_514_1112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3677.67 10368.6C449.901 10368.6 -2166.11 7752.18 -2166.11 4525.12C-2166.11 1297.52 449.901 -1318.91 3677.67 -1318.91C6905.44 -1318.91 9521.46 1297.52 9521.46 4525.12C9521.46 7752.18 6905.44 10368.6 3677.67 10368.6Z",
    fill: "url(#paint13_radial_514_1112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3187.17 1249.78C4983.48 -546.439 7896.33 -546.439 9692.64 1249.78C11489 3046.01 11489 5958.15 9692.64 7754.38C7896.33 9550.6 4983.48 9550.6 3187.17 7754.38C1390.85 5958.15 1390.85 3046.01 3187.17 1249.78Z",
    fill: "url(#paint14_radial_514_1112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4260.35 7731.88C2464.04 5935.66 2464.04 3022.97 4260.35 1226.74C6056.67 -569.481 8968.96 -569.481 10765.3 1226.74C12561.6 3022.97 12561.6 5935.66 10765.3 7731.88C8968.96 9528.11 6056.67 9528.11 4260.35 7731.88Z",
    fill: "url(#paint15_radial_514_1112)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_514_1112",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2556.61 -3213.93) scale(7472.64 7472.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#151722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#2B3258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C4783"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_514_1112",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6916.64 -3213.93) scale(7472.64 7472.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C0C0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_514_1112",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2007.95 -4223.41) scale(7472.64 7472.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#151722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#2B3258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C4783"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_514_1112",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4086.78 2375.11) rotate(135.001) scale(7472.46 7472.46)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C0C0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_514_1112",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(465.571 -2805.18) rotate(-90) scale(7472.29 7472.67)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C0C0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_514_1112",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4159.84 -2246.81) rotate(44.9985) scale(5881.64 5881.64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C0C0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_514_1112",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(130.598 -3815.8) rotate(-44.9985) scale(5881.64 5881.64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C0C0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_514_1112",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2989.9 -1342.56) scale(3663.34 3663.16)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C0C0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_514_1112",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6259.06 -1636.17) scale(3663.37 3663.18)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#151722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A6B8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_514_1112",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5098.94 7382.33) rotate(180) scale(11659.2 11658.6)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#3A4062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#242738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A58"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_514_1112",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-1703.76 7382.33) rotate(180) scale(11659.2 11658.6)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#151722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#2D3148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262B48"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_514_1112",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5954.99 8957.37) rotate(180) scale(11659.2 11658.6)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#151722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#2D3149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202647"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_514_1112",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2711.51 -1337.96) rotate(-44.9985) scale(11658.9 11658.9)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C0C0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_514_1112",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8361.46 6744.59) rotate(90) scale(11658.6 11659.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#151722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#252942"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F49"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_514_1112",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2597.53 5873.42) rotate(-135.001) scale(9176.79 9176.79)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#151722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#303652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D324D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_514_1112",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8884.15 8321.41) rotate(135.001) scale(9176.81 9176.81)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#151722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#2B304A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212434"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_514_1112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7374,
    height: 2809,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg13222AiPurp);
export default __webpack_public_path__ + "static/media/13222-ai_purp.56f5a2e27f5c94d0f4c1e0f30b850322.svg";
export { ForwardRef as ReactComponent };